import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export interface BillablePoint {
  x: string;
  y: number;
}

export interface BillableHoursResult {
  data?: BillablePoint[] | null;
  loading: boolean;
  error?: string;
}

export const useBillableHours = (
  username?: string,
  year?: string,
  quarter?: number,
  enabled: boolean = true
): BillableHoursResult => {
  const client = useMyProviderDataClient();

  const [data, setData] = useState<BillablePoint[] | null>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (!enabled || !username) return;

    const load = async () => {
      try {
        setLoading(true);
        setError(undefined);

        const res = await client.get(
          "/EmployeeInformation/BillableHours",
          { params: { username, year, quarter } }
        );

        const weeks = res.data;

        if (!Array.isArray(weeks)) {
          setData(null);
          return;
        }

        let billableHours: BillablePoint[] = weeks.map((week: any) => {
          const start = new Date(week.startDate);
          const end = new Date(week.endDate);

          const startString = `${start.getMonth() + 1}/${start.getDate()}`;
          const endString = `${end.getMonth() + 1}/${end.getDate()}`;

          return {
            x: `${startString}-${endString}`,
            y: week.hours ?? 0
          };
        });

        // If all values are 0 → return null (same logic as old code)
        const allZero = billableHours.every(w => w.y === 0);

        setData(allZero ? null : billableHours);

      } catch (err) {
        console.error(err);
        setError("Failed to load billable hours.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [username, year, quarter, enabled, client]);

  return { data, loading, error };
};